<template>
  <w-flex class="breadcrumbs-bar">
    <w-flex class="breadcrumbs-bar__list" align="center" :gap="3">
      <template v-for="(breadcrumb, index) in breadcrumbLinks" :key="'breadcrumb' + index">
        <w-button
          class="breadcrumbs-bar__item"
          variant="ghost"
          size="xs"
          :href="breadcrumb.Url"
          :icon="breadcrumb.Icon"
        >
          <span class="breadcrumbs-bar__item__text">{{ breadcrumb.Title }}</span>
        </w-button>

        <span v-if="index < breadcrumbLinks.length - 1"> / </span>
      </template>
    </w-flex>
  </w-flex>
</template>

<script setup lang="ts">
import type { BreadcrumbItem } from '@/typings/breadcrumbItem';

defineProps<{
  breadcrumbLinks: BreadcrumbItem[];
}>();
</script>

<style lang="scss">
.breadcrumbs-bar {
  background: w.color('neutral', 800);
  color: w.color('neutral', 100);
  padding: 12px w.size('layout-padding');
  font-size: w.font('small');

  display: flex;

  &__list {
    display: flex;
    gap: 8px;
  }

  &__item {
    color: w.color('neutral', 100);
    text-decoration: none;
    padding-left: 4px;
    padding-right: 4px;

    &__text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 15vw;
    }
  }
}
</style>
